"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLabelColumnFormatter = void 0;
const CertificationColumnFormatter_1 = require("./certification/CertificationColumnFormatter");
const CustomColumnFormatter_1 = require("./custom/CustomColumnFormatter");
const SensitivityColumnFormatter_1 = require("./sensitivity/SensitivityColumnFormatter");
const WarningColumnFormatter_1 = require("./warning/WarningColumnFormatter");
function createLabelColumnFormatter(category, props) {
    switch (category) {
        case 'warning':
            return (0, WarningColumnFormatter_1.createWarningColumnFormatter)(props);
        case 'certification':
            return (0, CertificationColumnFormatter_1.createCertificationColumnFormatter)(props);
        case 'sensitivity':
            return (0, SensitivityColumnFormatter_1.createSensitivityColumnFormatter)(props);
        case 'custom':
            return (0, CustomColumnFormatter_1.createCustomColumnFormatter)(props);
    }
}
exports.createLabelColumnFormatter = createLabelColumnFormatter;
//# sourceMappingURL=LabelCellFormatters.js.map